// service
// import appLogger from '../../loggers/appLogger';

// utils
import api from '../../utils/api';
import postingUtils from '../../utils/postingUtils';

import type { PropertyConstants } from '../../constants/PropertyConstants';
import type { APIResult } from '../../types/ApiResponseTypes';

const PostingActions = {
  property: {
    //  TODO: add deactivateLeases survey endpoint here
    // https://www.qa.zillow.net/rental-manager-api/docs?endpoint=%2Fapi%2Fv1%2Fusers%2Fproperties%2Fdeactivate%2Fleases
    create(formData: {
      listingType: keyof typeof PropertyConstants.LISTING_CODES_BY_TYPE;
      propertyType: (typeof PropertyConstants.PROPERTY_TYPES)[keyof typeof PropertyConstants.PROPERTY_TYPES];
      fullAddress: string;
      unitNumber?: string;
      numUnits?: string;
    }) {
      return async () => {
        const dataForApi = postingUtils.transformPropertyListingTypeForApi(formData);

        return await api.users.properties
          .create(dataForApi)
          .then((res: unknown) => {
            const response = res as APIResult;
            const { error: errorRMWModel, success } = response;

            if (success === false) {
              throw Promise.reject(errorRMWModel);
            }

            return response.response;
          })
          .catch((errorRMWModel) => {
            // appLogger.logError({
            //   message: errorRMWModel.message,
            //   context: 'PostingActions.property.create',
            // }); // logger is not supported on ZMC yet

            throw Promise.reject(errorRMWModel);
          });
      };
    },
  },
};

export default PostingActions;
